import { render } from "./EndScreenView.vue?vue&type=template&id=334723f2&scoped=true"
import script from "./EndScreenView.vue?vue&type=script&lang=js"
export * from "./EndScreenView.vue?vue&type=script&lang=js"

import "./EndScreenView.vue?vue&type=style&index=0&id=334723f2&scoped=true&lang=scss"
import "./EndScreenView.vue?vue&type=style&index=1&id=334723f2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334723f2"]])

export default __exports__